export function writeCookie(name, val, expires) {
    let date = new Date;
    date.setDate(date.getDate() + expires);
    document.cookie = encodeURIComponent(name)+"="+encodeURIComponent(val)+"; path=/; expires=" + date.toUTCString();
}

export function readCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const deleteCookie = (name) => {
    writeCookie(name, "", {
        expires: -1
    });
}
